//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CooperationForm from '@/views/packageA/_contact_us/cooperation_form'
export default {
    onShareAppMessage () {
        const sub_page = encodeURIComponent('/pages/packageA/contact_us/cooperation/main')
        return this.getShareInfo({
            title: `商务合作`,
            path: `/pages/index/main?sub_page=${sub_page}`
        })
    },
    components: {
        CooperationForm
    }
}
